// extracted by mini-css-extract-plugin
var _1 = "cUW49";
var _2 = "jqjw1";
var _3 = "C66Xt";
var _4 = "ku3CS elide";
var _5 = "MB55I";
var _6 = "onfsd";
var _7 = "q2Fn8";
var _8 = "WYesH";
var _9 = "i0nRG";
var _a = "ITvI0";
var _b = "ZFKKk";
export { _1 as "base", _2 as "disabled", _3 as "image", _4 as "label", _5 as "large", _6 as "medium", _7 as "showLabel", _8 as "small", _9 as "theme-dark", _a as "theme-light", _b as "xlarge" }
